<template>
	<div class="layout">
		<div id="layout-title">
			<div id="layout-title-left">
				<img src='/static/imgs/danju.png' class="jxyd-imgicon"/>
				待审核单据
			</div>
			<div id="layout-title-right">
				<Button class="jxyd-borderbtn" @click="toExamine">
					<Icon type="md-checkbox-outline" size='18' />
					审核
				</Button>
			</div>
		</div>
		<div id="layout-box">
			<div id="box-search">
				<Form ref="formSearch" :label-width="70" :model="searchItems" inline>
					<FormItem label="单据号">
						<Input type="text" v-model="searchItems.listCode" placeholder="单据号"
							@keyup.enter.native="initListData(1)" />
					</FormItem>
					<div style="display:inline-block;" v-show="advancedSelect">
						<FormItem label="业务日期">
						    <DatePicker ref="searchBusinessDate"
						                type="daterange"
						                show-week-numbers
						                placement="bottom-end"
						                placeholder="请选择日期"
						                @on-change='businessDateChange'
						                style="width:100%">
						    </DatePicker>
						</FormItem>
						<FormItem label="业务伙伴">
							<Input type="text" v-model="searchItems.businessPeopleName" placeholder="业务伙伴"
								@keyup.enter.native="initListData(1)" />
						</FormItem>
					</div>
					<FormItem :label-width="20">
						<button class="jxyd-button jxyd-primary" @click="initListData(1)" style="margin-right:10px;">查询</button>
						<button class="jxyd-button" @click="initSearch" style="margin-right:10px;">重置</button>
						<span @click="advancedSelect = true;" style="color:red;cursor: pointer;" v-if="!advancedSelect">
							展开
							<Icon type="ios-arrow-down" size='18'/>
						</span>
						<span @click="foldSearch" style="color:red;cursor: pointer;" v-else>
							折叠
							<Icon type="ios-arrow-up" size='18'/>
						</span>
					</FormItem>
				</Form>
			</div>
			<div id="box-table">
				<Table row-key="guid" :columns="tableColumns" :data="listData" @on-selection-change="auditListSeleChange"></Table>
			</div>
			<div id="page-box">
				<Page show-sizer :total="listCount" :page-size="searchItems.pageSize" @on-change="pageChange"
					show-total show-elevator :page-size-opts ='pageSizeOpts' :current="searchItems.pageIndex" @on-page-size-change='pageSizeChange'>
				</Page>
			</div>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatDate from '@/utils/formatDate'

	export default {
		name: 'auditlist',
		components: {},
		data() {
			return {
				searchItems: {
					listCode: '',
					userId: parseInt(localStorage.getItem("userId")),
					userName:'',
					totalBusinessDate:[],
					businessPeopleName: '',
					sort:'1',
					pageSize: 10,
					pageIndex: 1,
				},
				listData:[],
				listCount:0,
				tableColumns: [
					{
						type: 'selection',
						width: 60,
						align: 'center',
						fixed: 'left'
					},
					{
						title: '单据编号',
						key: 'code',
						render:(h, params)=> {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										let router = {};
										switch(params.row.listType){
											case '采购订单':
												router = {
													path: 'purchaseplanlistdetail',
													query: {
														planListCode: params.row.code
													}
												};
											break;
											case '采购单':
												router = {
													path: 'purchaselistdetail',
													query: {
														purchaseListCode: params.row.code
													}
												};
											break;
											case '采购退货单':
												router = {
													path: 'returnlistdetail',
													query: {
														returnListCode: params.row.code
													}
												};
											break;
											case '其它付款单':
												router = {
													path: 'othercostlistdetail',
													query: {
														otherCostListCode: params.row.code
													}
												};
											break;
											case '销售订单':
												router = {
													path: 'salesplanlistdetail',
													query: {
														salesListCode: params.row.code
													}
												};
											break;
											case '销售单':
												router = {
													path: 'saleslistdetail',
													query: {
														salesListCode: params.row.code
													}
												};
											break;
											case '销售退货单':
												router = {
													path: 'returnsaleslistdetail',
													query: {
														returnSalesListCode: params.row.code
													}
												};
											break;
											case '其它收款单':
												router = {
													path: 'otherreceiptlistdetail',
													query: {
														otherReceiptListCode: params.row.code
													}
												};
											break;
											case '付款单':
												router = {
													path: 'paymentlistdetail',
													query: {
														paymentListCode: params.row.code
													}
												};
											break;
											case '收款单':
												router = {
													path: 'receiptlistdetail',
													query: {
														receiptListCode: params.row.code
													}
												};
											break;
											case '商品调拨单':
												router = {
													path: 'commodityallocationlistdetail',
													query: {
														allocationListCode: params.row.code
													}
												};
											break;
											case '成本调整单':
												router = {
													path: 'commoditycostadjustlistdetail',
													query: {
														costAdjustListCode: params.row.code
													}
												};
											break;
											case '其它入库单':
												router = {
													path: 'enterstorelistdetail',
													query: {
														enterStoreListCode: params.row.code
													}
												};
											break;
											case '其它出库单':
												router = {
													path: 'outstorelistdetail',
													query: {
														outStoreListCode: params.row.code
													}
												};
											break;
										}
										this.$router.push(router);
									}
								}
							}, " " + params.row.code)
						}
					},
					{
						title: '单据类型',
						key: 'listType',
						render:(h, params) => {
							return h('Tag', {
								style: {},
								attrs: {
									color: 'magenta'
								}
							}, params.row.listType);
						}
					},
					{
						title: '业务员',
						key: 'userDisplayName'
					},
					{
						title: '业务日期',
						key: 'businessDate',
						render: (h, params) => {
							return h('span', {}, formatDate(new Date(params.row.businessDate), 'yyyy-MM-dd'));
						}
					},
					{
						title: '业务伙伴',
						key: 'businessPeopleName'
					}
				],
				advancedSelect: false,
				pageSizeOpts:[10,20,30,40,50,60,70,80,90,100],
				tableRowObjs:[],
				tableRowIds:[]
			}
		},

		methods: {
			initListData(index) {
				let component = this;
				component.searchItems.pageIndex = index;
				request.post('/api/Home/GetFlowListByWeb', component.searchItems).then(function(response) {
					if (response.state == 0) {
						component.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					component.listData = response.data.lists;
					component.listCount = response.data.count;
				}).catch(function(error) {})
			},
			pageChange(index) {
				this.initListData(index);
			},
			pageSizeChange(pageSize){
				this.searchItems.pageSize = pageSize;
				this.initListData(1);
			},
			foldSearch() {
				this.advancedSelect = false;
				this.searchItems.userId = parseInt(localStorage.getItem("userId"));
				this.$refs.searchBusinessDate.handleClear();
				this.searchItems.businessPeopleName = '';
			},
			initSearch() {
				this.searchItems.listCode = '';
				this.searchItems.userId = parseInt(localStorage.getItem("userId"));
				this.$refs.searchBusinessDate.handleClear();
				this.searchItems.businessPeopleName = '';
			},
			businessDateChange(val) {
				if (val[0]) {
					this.searchItems.totalBusinessDate = val;
				} else {
					this.searchItems.totalBusinessDate = [];
				}
			},
			toExamine() {
				if(this.tableRowObjs.length <= 0){
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中数据"
					});
					return
				}
				let self = this
				let serverList = []
				let isExist = false
				for (let i = 0; i < this.tableRowObjs.length; i++) {
					switch (this.tableRowObjs[i].listType) {
						case '采购订单':
							isExist = false
							for (let n = 0; n < serverList.length; n++) {
								if (serverList[n].serverPath == '/api/PurchasePlanList/CheckPurchasePlanList') {
									serverList[n].obj.ids.push(this.tableRowObjs[i].id)
									isExist = true
									break;
								}
							}
							if (!isExist) {
								serverList.push({
									serverPath: '/api/PurchasePlanList/CheckPurchasePlanList',
									obj: {
										ids: [this.tableRowObjs[i].id],
										state: 2
									}
								})
							}
							break;
						case '采购单':
							isExist = false
							for (let n = 0; n < serverList.length; n++) {
								if (serverList[n].serverPath == '/api/PurchaseList/CheckPurchaseList') {
									serverList[n].obj.push({
										id: this.tableRowObjs[i].id,
										state: 2
									})
									isExist = true
									break;
								}
							}
							if (!isExist) {
								serverList.push({
									serverPath: '/api/PurchaseList/CheckPurchaseList',
									obj: [{
										id: this.tableRowObjs[i].id,
										state: 2
									}]
								})
							}
						case '采购退货单':
							isExist = false
							for (let n = 0; n < serverList.length; n++) {
								if (serverList[n].serverPath == '/api/ReturnList/CheckReturnList') {
									serverList[n].obj.push({
										id: this.tableRowObjs[i].id,
										state: 2
									})
									isExist = true
									break;
								}
							}
							if (!isExist) {
								serverList.push({
									serverPath: '/api/ReturnList/CheckReturnList',
									obj: [{
										id: this.tableRowObjs[i].id,
										state: 2
									}]
								})
							}
							break;
						case '其它付款单':
							isExist = false
							for (let n = 0; n < serverList.length; n++) {
								if (serverList[n].serverPath == '/api/OtherCostList/CheckOtherCostList') {
									serverList[n].obj.push({
										id: this.tableRowObjs[i].id,
										state: 2
									})
									isExist = true
									break;
								}
							}
							if (!isExist) {
								serverList.push({
									serverPath: '/api/OtherCostList/CheckOtherCostList',
									obj: [{
										id: this.tableRowObjs[i].id,
										state: 2
									}]
								})
							}
							break;
						case '销售订单':
							isExist = false
							for (let n = 0; n < serverList.length; n++) {
								if (serverList[n].serverPath == '/api/SalesPlanList/CheckSalesPlanList') {
									serverList[n].obj.ids.push(this.tableRowObjs[i].id)
									isExist = true
									break;
								}
							}
							if (!isExist) {
								serverList.push({
									serverPath: '/api/SalesPlanList/CheckSalesPlanList',
									obj: {
										ids: [this.tableRowObjs[i].id],
										state: 2
									}
								})
							}
							break;
						case '销售单':
							isExist = false
							for (let n = 0; n < serverList.length; n++) {
								if (serverList[n].serverPath == '/api/SalesList/CheckSalesList') {
									serverList[n].obj.push({
										id: this.tableRowObjs[i].id,
										state: 2
									})
									isExist = true
									break;
								}
							}
							if (!isExist) {
								serverList.push({
									serverPath: '/api/SalesList/CheckSalesList',
									obj: [{
										id: this.tableRowObjs[i].id,
										state: 2
									}]
								})
							}
							break;
						case '销售退货单':
							isExist = false
							for (let n = 0; n < serverList.length; n++) {
								if (serverList[n].serverPath == '/api/ReturnSalesList/CheckReturnSalesList') {
									serverList[n].obj.push({
										id: this.tableRowObjs[i].id,
										state: 2
									})
									isExist = true
									break;
								}
							}
							if (!isExist) {
								serverList.push({
									serverPath: '/api/ReturnSalesList/CheckReturnSalesList',
									obj: [{
										id: this.tableRowObjs[i].id,
										state: 2
									}]
								})
							}
							break;
						case '其它收款单':
							isExist = false
							for (let n = 0; n < serverList.length; n++) {
								if (serverList[n].serverPath == '/api/OtherReceiptList/CheckOtherReceiptList') {
									serverList[n].obj.push({
										id: this.tableRowObjs[i].id,
										state: 2
									})
									isExist = true
									break;
								}
							}
							if (!isExist) {
								serverList.push({
									serverPath: '/api/OtherReceiptList/CheckOtherReceiptList',
									obj: [{
										id: this.tableRowObjs[i].id,
										state: 2
									}]
								})
							}
							break;
						case '付款单':
							isExist = false
							for (let n = 0; n < serverList.length; n++) {
								if (serverList[n].serverPath == '/api/PaymentList/CheckPaymentList') {
									serverList[n].obj.push({
										id: this.tableRowObjs[i].id,
										state: 2
									})
									isExist = true
									break;
								}
							}
							if (!isExist) {
								serverList.push({
									serverPath: '/api/PaymentList/CheckPaymentList',
									obj: [{
										id: this.tableRowObjs[i].id,
										state: 2
									}]
								})
							}
							break;
						case '收款单':
							isExist = false
							for (let n = 0; n < serverList.length; n++) {
								if (serverList[n].serverPath == '/api/ReceiptList/CheckReceiptList') {
									serverList[n].obj.push({
										id: this.tableRowObjs[i].id,
										state: 2
									})
									isExist = true
									break;
								}
							}
							if (!isExist) {
								serverList.push({
									serverPath: '/api/ReceiptList/CheckReceiptList',
									obj: [{
										id: this.tableRowObjs[i].id,
										state: 2
									}]
								})
							}
							break;
						case '商品调拨单':
							isExist = false
							for (let n = 0; n < serverList.length; n++) {
								if (serverList[n].serverPath == '/api/CommodityAllocationList/CheckCommodityAllocationList') {
									serverList[n].obj.push({
										id: this.tableRowObjs[i].id,
										state: 2
									})
									isExist = true
									break;
								}
							}
							if (!isExist) {
								serverList.push({
									serverPath: '/api/CommodityAllocationList/CheckCommodityAllocationList',
									obj: [{
										id: this.tableRowObjs[i].id,
										state: 2
									}]
								})
							}
							break;
						case '成本调整单':
							isExist = false
							for (let n = 0; n < serverList.length; n++) {
								if (serverList[n].serverPath == '/api/CommodityCostAdjustList/CheckCommodityCostAdjustList') {
									serverList[n].obj.push({
										id: this.tableRowObjs[i].id,
										state: 2
									})
									isExist = true
									break;
								}
							}
							if (!isExist) {
								serverList.push({
									serverPath: '/api/CommodityCostAdjustList/CheckCommodityCostAdjustList',
									obj: [{
										id: this.tableRowObjs[i].id,
										state: 2
									}]
								})
							}
							break;
						case '其它入库单':
							isExist = false
							for (let n = 0; n < serverList.length; n++) {
								if (serverList[n].serverPath == '/api/EnterStoreList/CheckEnterStoreList') {
									serverList[n].obj.push({
										id: this.tableRowObjs[i].id,
										state: 2
									})
									isExist = true
									break;
								}
							}
							if (!isExist) {
								serverList.push({
									serverPath: '/api/EnterStoreList/CheckEnterStoreList',
									obj: [{
										id: this.tableRowObjs[i].id,
										state: 2
									}]
								})
							}
							break;
						case '其它出库单':
							isExist = false
							for (let n = 0; n < serverList.length; n++) {
								if (serverList[n].serverPath == '/api/OutStoreList/CheckOutStoreList') {
									serverList[n].obj.push({
										id: this.tableRowObjs[i].id,
										state: 2
									})
									isExist = true
									break;
								}
							}
							if (!isExist) {
								serverList.push({
									serverPath: '/api/OutStoreList/CheckOutStoreList',
									obj: [{
										id: this.tableRowObjs[i].id,
										state: 2
									}]
								})
							}
							break;
					}
				}
				this.$Modal.confirm({
					title: "操作警告",
					content: '单据审核/过账后不可更改，内容不可编辑，是否继续操作？',
					onOk() {
						for (let i = 0; i < serverList.length; i++) {
							request.post(serverList[i].serverPath, serverList[i].obj).then(function(result) {
								if (result.state != 1) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: "审核失败"
									});
									return
								}
								self.initListData(1)
							}).catch(err => {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: "审核失败"
								});
							})
						}
					},
					onCancel() {}
				});
			},
			pageSizeChange(pageSize){
				this.searchItems.pageSize = pageSize;
				this.initListData(1);
			},
			pageChange(index) {
				this.initListData(index);
			},
			auditListSeleChange(items){
				this.tableRowIds = [];
				for (var i = 0; i < items.length; i++) {
					this.tableRowIds.push(items[i].id);
				}
				this.tableRowObjs = items;
			}
		},
		watch: {},
		created: function() {
			this.initListData(1);
		}
	}
</script>

<style scoped>
	.layout {
		background: #fff;
		border-radius: 8px;
		padding: 5px 10px;
	}

	#layout-title {
		overflow: hidden;
		padding: 5px;
		font-size: 16px;
		border-bottom: 1px solid #e8eaec;
	}

	#box-search {
		padding-top: 20px;
	}

	#layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	#layout-title-right {
		float: right;
	}

	#page-box {
		margin-top: 20px;
		text-align: center;
	}
</style>